import ApplicationController from '../application_controller'

class UserSignatureController extends ApplicationController {
  static targets = ['signature', 'rendered']

  connect() {
    $(this.signatureTarget).on('change', this.renderSignature.bind(this))
  }

  renderSignature() {
    const selected = this.signatureTarget.value
    const url = `${this.signatureTarget.dataset['url']}/${selected}`

    if (selected) {
      fetch(url)
        .then(response => {
          switch (response.status) {
            case 200:
              return response.text()
            default:
              throw response
          }
        })
        .then(data => this.renderedTarget.innerHTML = data)
        .catch(() => this.renderedTarget.innerHTML = '')
    } else {
      this.renderedTarget.innerHTML = ''
    }
  }
}

export default UserSignatureController
